export default {
  props: {
    size: {
      type: String,
      validator(val) {
        return ["large", "medium", "small", "custom"].includes(val)
      },
    },
  },

  computed: {
    themeClasses() {
      return {
        mm__theme: this.size,
        [`mm__theme-size__${this.size}`]: this.size,
      }
    },
  },
}
